import { patchState, StateSignals, WritableStateSource } from '@ngrx/signals';

import { FileExportState, FileManagerListItem } from './file-export.store';
import { ExportJobId } from '../models/export-data.type';
import { Subscription } from 'rxjs';

export const fileExportDataAdapterMethodsFactory = (store: StateSignals<FileExportState> & WritableStateSource<FileExportState>) => ({
  addFile: (jobId: ExportJobId['jobId'], fileName: string, subscription: Subscription, rest?: Record<string, string>) => {
    patchState(store, (state) => ({
      ...state,
      files: [
        ...state.files,
        { id: jobId, name: fileName, status: 'pending', subscription: subscription, queryParams: rest } as FileManagerListItem,
      ],
    }));
  },
  updateStatus: (jobId: ExportJobId['jobId'], status: FileManagerListItem['status']) => {
    patchState(store, (state) => ({ ...state, files: state.files.map((file) => (file.id === jobId ? { ...file, status } : file)) }));
  },
  removeFile: (jobId: FileManagerListItem['id']) => {
    const file = store.files().find((file) => file.id === jobId);
    if (file) {
      file.subscription.unsubscribe();
      patchState(store, (state) => ({ ...state, files: state.files.filter((file) => file.id !== jobId) }));
    }
  },
  clearCompletedFiles: () => {
    patchState(store, (state) => ({ ...state, files: state.files.filter((file) => file.status === 'pending') }));
  },
});
